import { BOOK_LANGUAGES } from '../../../utils/mockData';

export const WHY_EXISTS_COPY = {
  title: 'Why ZeroUp Reads Exists',
  body: "A world where every child can learn in the language they think in. Whether it's understanding the solar system, the human body, artificial intelligence, or African history, knowledge should never be limited by language.",
};

// Languages Map card lists real supported languages — pulled from the same
// canonical taxonomy every filter/upload dropdown uses, not a hardcoded list
// that could drift from what the Library page actually supports.
export const MAP_LANGUAGES = BOOK_LANGUAGES;

export const MAP_COPY = {
  title: "Keeping Africa's Languages Alive",
  tagline: "Knowledge shouldn't come at the cost of culture.",
  body: "Every language carries stories, history, identity, and wisdom. As more indigenous languages face extinction, ZeroUp Reads is creating books and learning materials that help children read, learn, and grow in their mother tongue—preserving Africa's linguistic heritage for generations to come.",
};
